import { render, staticRenderFns } from "./FilesListTableHeader.vue?vue&type=template&id=12d5b60e&scoped=true"
import script from "./FilesListTableHeader.vue?vue&type=script&lang=ts"
export * from "./FilesListTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./FilesListTableHeader.vue?vue&type=style&index=0&id=12d5b60e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d5b60e",
  null
  
)

export default component.exports